"use client";

import type { DayOfWeek } from "@repo/api";
import { ToggleGroup, ToggleGroupItem } from "@repo/ui/components/ui/toggle-group";
import { Field, FieldError, FieldLabel } from "@repo/ui/form-fields";
import { useFieldContext } from "@/shared/forms/form-context";

const DAYS: { value: DayOfWeek; label: string }[] = [
  { value: "sun", label: "S" },
  { value: "mon", label: "M" },
  { value: "tue", label: "T" },
  { value: "wed", label: "W" },
  { value: "thu", label: "T" },
  { value: "fri", label: "F" },
  { value: "sat", label: "S" },
];

export interface DayOfWeekFieldProps {
  label?: string;
  disabled?: boolean;
}

export function DayOfWeekField({ label, disabled }: DayOfWeekFieldProps) {
  const field = useFieldContext<DayOfWeek[]>();

  return (
    <Field errors={field.state.meta.errors} isTouched={field.state.meta.isTouched}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <ToggleGroup
        multiple
        value={field.state.value}
        onValueChange={
          disabled
            ? undefined
            : (value) => {
                field.handleChange(value as DayOfWeek[]);
                field.handleBlur();
              }
        }
        className={`justify-start ${label ? "mt-1" : ""}`}
        disabled={disabled}
      >
        {DAYS.map((day, i) => (
          <ToggleGroupItem
            key={day.value}
            value={day.value}
            className="w-9 h-9"
            aria-label={day.value}
            disabled={disabled}
          >
            {day.label}
            {/* Disambiguate T and S */}
            {(i === 2 || i === 4) && <span className="sr-only">{i === 2 ? "ue" : "hu"}</span>}
            {(i === 0 || i === 6) && <span className="sr-only">{i === 0 ? "un" : "at"}</span>}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      <FieldError />
    </Field>
  );
}
